import {
	Accordion,
	AccordionGroup,
	Asset,
	Badges,
	Banner,
	BrandsContentful,
	ButtonContentful,
	CarouselContentful,
	CategoryInclude,
	ContentCardContentful,
	CTA,
	FlatNavigationItem,
	FlatNavigationItemContainer,
	GridContentful,
	IFrame,
	ImageContentful,
	ModuleContentful,
	NavigationItem,
	Page,
	PaginatedContentContentful,
	PersonalizedBlock,
	Placeholder,
	ProductInclude,
	ProductTileContentful,
	TabsContentful,
	Text,
	ContentfulVideo,
	ScrollingStripeBanner
} from './components';

export const componentsMap = {
	Accordion: Accordion,
	AccordionGroup: AccordionGroup,
	Asset: Asset,
	Badge: Badges,
	Banner: Banner,
	Brands: BrandsContentful,
	Button: ButtonContentful,
	Carousel: CarouselContentful,
	CategoryInclude: CategoryInclude,
	ContentCard: ContentCardContentful,
	Cta: CTA,
	FlatNavigationItem: FlatNavigationItem,
	FlatNavigationItemContainer: FlatNavigationItemContainer,
	Grid: GridContentful,
	GridRow: GridContentful.Row,
	GridColumn: GridContentful.Column,
	IFrame: IFrame,
	Image: ImageContentful,
	Module: ModuleContentful,
	ScrollingStripeBanner: ScrollingStripeBanner,
	NavigationItem: NavigationItem,
	Page: Page,
	PaginatedContent: PaginatedContentContentful,
	PersonalizedBlock: PersonalizedBlock,
	Placeholder: Placeholder,
	ProductInclude: ProductInclude,
	ProductTile: ProductTileContentful,
	Tabs: TabsContentful,
	Tab: TabsContentful.Tab,
	Text: Text,
	Video: ContentfulVideo,
};
